
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Culture() {
  const section = useScrollAnimation();

  const perks = [
    { icon: 'ri-heart-pulse-line', label: 'Health & Wellness' },
    { icon: 'ri-home-office-line', label: 'Remote Flexibility' },
    { icon: 'ri-graduation-cap-line', label: 'Learning Budget' },
    { icon: 'ri-plane-line', label: 'Unlimited PTO' },
    { icon: 'ri-stock-line', label: 'Equity Options' },
    { icon: 'ri-team-line', label: 'Team Retreats' },
  ];

  return (
    <section className="py-28 px-8 bg-[#F9FAFB]">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div
            ref={section.ref}
            className={`relative transition-all duration-1000 ${
              section.isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
            }`}
          >
            <div className="grid grid-cols-2 gap-4">
              <div className="w-full h-[280px] rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/c5c17e9bf4db58665ce4c4f2c4357057.jpg"
                  alt="Team celebration"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-full h-[280px] rounded-2xl overflow-hidden mt-8">
                <img
                  src="https://readdy.ai/api/search-image?query=Creative%20brainstorming%20session%20with%20sticky%20notes%20on%20glass%20wall%20in%20modern%20tech%20office%2C%20diverse%20professionals%20collaborating%20on%20innovative%20ideas%2C%20bright%20natural%20lighting%2C%20contemporary%20minimalist%20workspace%20design%2C%20warm%20and%20inspiring%20atmosphere%2C%20candid%20photography&width=400&height=280&seq=about-culture-002&orientation=landscape"
                  alt="Creative brainstorming"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-full h-[280px] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20tech%20company%20lounge%20area%20with%20comfortable%20seating%20and%20people%20having%20casual%20conversation%2C%20indoor%20plants%20and%20warm%20lighting%2C%20contemporary%20office%20design%20with%20wood%20and%20glass%20elements%2C%20relaxed%20professional%20atmosphere%2C%20warm%20tones%20photography&width=400&height=280&seq=about-culture-003&orientation=landscape"
                  alt="Office lounge"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-full h-[280px] rounded-2xl overflow-hidden mt-8">
                <img
                  src="https://readdy.ai/api/search-image?query=Team%20outdoor%20retreat%20activity%20with%20professionals%20doing%20team%20building%20exercises%20in%20nature%2C%20sunny%20day%20with%20green%20landscape%2C%20casual%20corporate%20event%20photography%2C%20people%20laughing%20and%20bonding%2C%20warm%20golden%20hour%20lighting%2C%20energetic%20and%20fun%20atmosphere&width=400&height=280&seq=about-culture-004&orientation=landscape"
                  alt="Team retreat"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          <div
            className={`transition-all duration-1000 delay-200 ${
              section.isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'
            }`}
          >
            <span className="text-xs font-semibold text-[#0066CC] uppercase tracking-[0.2em] mb-4 block">Life at TechVision</span>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2332] mb-6 leading-tight">
              Where great people do their best work
            </h2>
            <p className="text-base text-gray-600 leading-relaxed mb-10">
              We believe that exceptional results come from exceptional environments. Our culture is built on trust, autonomy, and a shared passion for solving complex problems. We invest in our people because they are the foundation of everything we build.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              {perks.map((perk, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 border border-gray-100"
                >
                  <div className="w-8 h-8 rounded-lg bg-[#0066CC]/10 flex items-center justify-center shrink-0">
                    <i className={`${perk.icon} text-base text-[#0066CC]`}></i>
                  </div>
                  <span className="text-sm font-medium text-[#1A2332]">{perk.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
